"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowUpLeft, ArrowUpRight, Crown } from "lucide-react";
import { BID_STATUS, formatDateTime, formatPrice, STATUS_LABEL } from "@/features/auctions/v2/single/format";
import { Seal } from "@/features/home-v2/desk/Desk";
import { chainName } from "@/features/home-v2/tiles";
import { formatTokenSymbol } from "@/lib/asset-naming";
import type { BidItem } from "../../types";
const TONE = {
  pending: "accent",
  accepted: "up",
  rejected: "down"
} as const;

/**
 * One bid in the ledger — every fact MyBidsClient's card listed, as a ruled
 * row: its state (and the crown when it won), the auction it was placed on
 * and its number, the amount on the figures' right edge, when it was placed,
 * the chain and currency, and the auction's own state. On a phone the row
 * becomes a small card and each fact wears its label.
 */
export default function MyBidRow(t0) {
  const $ = _c(131);
  const {
    bid,
    lang
  } = t0;
  const isFa = lang === "fa";
  let t1;
  if ($[0] !== isFa) {
    t1 = (fa, en) => isFa ? fa : en;
    $[0] = isFa;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t = t1;
  let Go;
  let auctionStatus;
  let chain;
  let currency;
  let href;
  let symbol;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let title;
  if ($[2] !== bid.auction || $[3] !== bid.auction_id || $[4] !== bid.currency?.name || $[5] !== bid.currency?.symbol || $[6] !== bid.id || $[7] !== bid.is_win || $[8] !== bid.network?.fa_name || $[9] !== bid.network?.name || $[10] !== bid.status || $[11] !== isFa || $[12] !== lang || $[13] !== t) {
    const idf = new Intl.NumberFormat(isFa ? "fa-IR" : "en-US", {
      useGrouping: false
    });
    href = bid.auction?.slug ? `/${lang}/auctions/${bid.auction.slug}` : null;
    let t12;
    if ($[31] !== bid.auction?.title || $[32] !== bid.auction_id || $[33] !== t) {
      t12 = bid.auction?.title || `${t("\u0645\u0632\u0627\u06CC\u062F\u0647", "Auction")} #${bid.auction_id}`;
      $[31] = bid.auction?.title;
      $[32] = bid.auction_id;
      $[33] = t;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    title = t12;
    const status = BID_STATUS[bid.status];
    auctionStatus = bid.auction?.status ? STATUS_LABEL[bid.auction.status] : null;
    const t13 = bid.currency?.symbol;
    let t14;
    if ($[35] !== t13) {
      t14 = formatTokenSymbol(t13);
      $[35] = t13;
      $[36] = t14;
    } else {
      t14 = $[36];
    }
    symbol = t14;
    const t15 = bid.network?.name || bid.network?.fa_name;
    let t16;
    if ($[37] !== isFa || $[38] !== t15) {
      t16 = chainName(t15, isFa);
      $[37] = isFa;
      $[38] = t15;
      $[39] = t16;
    } else {
      t16 = $[39];
    }
    chain = t16;
    currency = bid.currency?.name || symbol;
    Go = isFa ? ArrowUpLeft : ArrowUpRight;
    t8 = "mb-row";
    t9 = bid.status;
    t10 = bid.is_win || undefined;
    const t17 = TONE[bid.status] ?? "muted";
    const t18 = status ? isFa ? status[0] : status[1] : bid.status;
    let t19;
    if ($[40] !== t17 || $[41] !== t18) {
      t19 = <Seal tone={t17}>{t18}</Seal>;
      $[40] = t17;
      $[41] = t18;
      $[42] = t19;
    } else {
      t19 = $[42];
    }
    let t20;
    if ($[43] !== bid.is_win || $[44] !== t) {
      t20 = bid.is_win ? <Seal tone="gold"><Crown aria-hidden={true} />{t("\u0628\u0631\u0646\u062F\u0647", "Won")}</Seal> : null;
      $[43] = bid.is_win;
      $[44] = t;
      $[45] = t20;
    } else {
      t20 = $[45];
    }
    if ($[46] !== t19 || $[47] !== t20) {
      t11 = <div className="mb-c mb-c--state">{t19}{t20}</div>;
      $[46] = t19;
      $[47] = t20;
      $[48] = t11;
    } else {
      t11 = $[48];
    }
    t6 = "mb-c mb-c--auction";
    if ($[49] !== href || $[50] !== title) {
      t7 = href ? <Link href={href} className="v2-focus">{title}</Link> : <span>{title}</span>;
      $[49] = href;
      $[50] = title;
      $[51] = t7;
    } else {
      t7 = $[51];
    }
    if ($[52] !== t) {
      t4 = t("\u067E\u06CC\u0634\u0646\u0647\u0627\u062F", "Bid");
      $[52] = t;
      $[53] = t4;
    } else {
      t4 = $[53];
    }
    t5 = " ";
    t2 = "#";
    t3 = idf.format(bid.id);
    $[2] = bid.auction;
    $[3] = bid.auction_id;
    $[4] = bid.currency?.name;
    $[5] = bid.currency?.symbol;
    $[6] = bid.id;
    $[7] = bid.is_win;
    $[8] = bid.network?.fa_name;
    $[9] = bid.network?.name;
    $[10] = bid.status;
    $[11] = isFa;
    $[12] = lang;
    $[13] = t;
    $[14] = Go;
    $[15] = auctionStatus;
    $[16] = chain;
    $[17] = currency;
    $[18] = href;
    $[19] = symbol;
    $[20] = t10;
    $[21] = t11;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = title;
  } else {
    Go = $[14];
    auctionStatus = $[15];
    chain = $[16];
    currency = $[17];
    href = $[18];
    symbol = $[19];
    t10 = $[20];
    t11 = $[21];
    t2 = $[22];
    t3 = $[23];
    t4 = $[24];
    t5 = $[25];
    t6 = $[26];
    t7 = $[27];
    t8 = $[28];
    t9 = $[29];
    title = $[30];
  }
  let t12;
  if ($[54] !== t2 || $[55] !== t3) {
    t12 = <bdi>{t2}{t3}</bdi>;
    $[54] = t2;
    $[55] = t3;
    $[56] = t12;
  } else {
    t12 = $[56];
  }
  let t13;
  if ($[57] !== t12 || $[58] !== t4 || $[59] !== t5) {
    t13 = <small>{t4}{t5}{t12}</small>;
    $[57] = t12;
    $[58] = t4;
    $[59] = t5;
    $[60] = t13;
  } else {
    t13 = $[60];
  }
  let t14;
  if ($[61] !== t13 || $[62] !== t6 || $[63] !== t7) {
    t14 = <div className={t6}>{t7}{t13}</div>;
    $[61] = t13;
    $[62] = t6;
    $[63] = t7;
    $[64] = t14;
  } else {
    t14 = $[64];
  }
  let t15;
  if ($[65] !== t) {
    t15 = t("\u0645\u0628\u0644\u063A \u067E\u06CC\u0634\u0646\u0647\u0627\u062F", "Amount");
    $[65] = t;
    $[66] = t15;
  } else {
    t15 = $[66];
  }
  let t16;
  if ($[67] !== t15) {
    t16 = <span className="mb-k">{t15}</span>;
    $[67] = t15;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== bid.price || $[70] !== isFa) {
    t17 = formatPrice(bid.price, isFa);
    $[69] = bid.price;
    $[70] = isFa;
    $[71] = t17;
  } else {
    t17 = $[71];
  }
  let t18;
  if ($[72] !== t17) {
    t18 = <bdi>{t17}</bdi>;
    $[72] = t17;
    $[73] = t18;
  } else {
    t18 = $[73];
  }
  let t19;
  if ($[74] !== symbol) {
    t19 = symbol ? <small>{symbol}</small> : null;
    $[74] = symbol;
    $[75] = t19;
  } else {
    t19 = $[75];
  }
  let t20;
  if ($[76] !== t18 || $[77] !== t19) {
    t20 = <span className="mb-v">{t18}{t19}</span>;
    $[76] = t18;
    $[77] = t19;
    $[78] = t20;
  } else {
    t20 = $[78];
  }
  let t21;
  if ($[79] !== t16 || $[80] !== t20) {
    t21 = <div className="mb-c mb-c--price">{t16}{t20}</div>;
    $[79] = t16;
    $[80] = t20;
    $[81] = t21;
  } else {
    t21 = $[81];
  }
  let t22;
  if ($[82] !== t) {
    t22 = t("\u0632\u0645\u0627\u0646 \u062B\u0628\u062A", "Placed");
    $[82] = t;
    $[83] = t22;
  } else {
    t22 = $[83];
  }
  let t23;
  if ($[84] !== t22) {
    t23 = <span className="mb-k">{t22}</span>;
    $[84] = t22;
    $[85] = t23;
  } else {
    t23 = $[85];
  }
  let t24;
  if ($[86] !== bid.created_at || $[87] !== isFa) {
    t24 = formatDateTime(bid.created_at, isFa);
    $[86] = bid.created_at;
    $[87] = isFa;
    $[88] = t24;
  } else {
    t24 = $[88];
  }
  let t25;
  if ($[89] !== t24) {
    t25 = <span className="mb-v">{t24}</span>;
    $[89] = t24;
    $[90] = t25;
  } else {
    t25 = $[90];
  }
  let t26;
  if ($[91] !== t23 || $[92] !== t25) {
    t26 = <div className="mb-c mb-c--when">{t23}{t25}</div>;
    $[91] = t23;
    $[92] = t25;
    $[93] = t26;
  } else {
    t26 = $[93];
  }
  let t27;
  if ($[94] !== t) {
    t27 = t("\u0634\u0628\u06A9\u0647 \u0648 \u0627\u0631\u0632", "Chain \xB7 currency");
    $[94] = t;
    $[95] = t27;
  } else {
    t27 = $[95];
  }
  let t28;
  if ($[96] !== t27) {
    t28 = <span className="mb-k">{t27}</span>;
    $[96] = t27;
    $[97] = t28;
  } else {
    t28 = $[97];
  }
  const t29 = chain || "\u2014";
  let t30;
  if ($[98] !== currency) {
    t30 = currency ? <><i aria-hidden={true}>·</i><bdi>{currency}</bdi></> : null;
    $[98] = currency;
    $[99] = t30;
  } else {
    t30 = $[99];
  }
  let t31;
  if ($[100] !== t29 || $[101] !== t30) {
    t31 = <span className="mb-v">{t29}{t30}</span>;
    $[100] = t29;
    $[101] = t30;
    $[102] = t31;
  } else {
    t31 = $[102];
  }
  let t32;
  if ($[103] !== t28 || $[104] !== t31) {
    t32 = <div className="mb-c mb-c--chain">{t28}{t31}</div>;
    $[103] = t28;
    $[104] = t31;
    $[105] = t32;
  } else {
    t32 = $[105];
  }
  let t33;
  if ($[106] !== t) {
    t33 = t("\u0648\u0636\u0639\u06CC\u062A \u0645\u0632\u0627\u06CC\u062F\u0647", "Auction");
    $[106] = t;
    $[107] = t33;
  } else {
    t33 = $[107];
  }
  let t34;
  if ($[108] !== t33) {
    t34 = <span className="mb-k">{t33}</span>;
    $[108] = t33;
    $[109] = t34;
  } else {
    t34 = $[109];
  }
  const t35 = auctionStatus ? isFa ? auctionStatus[0] : auctionStatus[1] : bid.auction?.status || "\u2014";
  let t36;
  if ($[110] !== t35) {
    t36 = <span className="mb-v">{t35}</span>;
    $[110] = t35;
    $[111] = t36;
  } else {
    t36 = $[111];
  }
  let t37;
  if ($[112] !== t34 || $[113] !== t36) {
    t37 = <div className="mb-c mb-c--auc">{t34}{t36}</div>;
    $[112] = t34;
    $[113] = t36;
    $[114] = t37;
  } else {
    t37 = $[114];
  }
  let t38;
  if ($[115] !== Go || $[116] !== href || $[117] !== t || $[118] !== title) {
    t38 = href ? <Link href={href} className="mb-go v2-focus" aria-label={`${t("\u0645\u0634\u0627\u0647\u062F\u0647\u200C\u06CC \u0645\u0632\u0627\u06CC\u062F\u0647", "View the auction")}: ${title}`}><Go aria-hidden={true} /></Link> : <span className="mb-go" aria-hidden={true} />;
    $[115] = Go;
    $[116] = href;
    $[117] = t;
    $[118] = title;
    $[119] = t38;
  } else {
    t38 = $[119];
  }
  let t39;
  if ($[120] !== t10 || $[121] !== t11 || $[122] !== t14 || $[123] !== t21 || $[124] !== t26 || $[125] !== t32 || $[126] !== t37 || $[127] !== t38 || $[128] !== t8 || $[129] !== t9) {
    t39 = <li className={t8} data-status={t9} data-win={t10}>{t11}{t14}{t21}{t26}{t32}{t37}{t38}</li>;
    $[120] = t10;
    $[121] = t11;
    $[122] = t14;
    $[123] = t21;
    $[124] = t26;
    $[125] = t32;
    $[126] = t37;
    $[127] = t38;
    $[128] = t8;
    $[129] = t9;
    $[130] = t39;
  } else {
    t39 = $[130];
  }
  return t39;
}